import { ApplicationConfig, ErrorHandler, InjectionToken, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

import { routes } from './app.routes';
import { DatePipe } from '@angular/common';
import { environment } from '../environments/environment';


export const ENVIRONMENT_TOKEN = new InjectionToken<string>('environment');

export const appConfig: ApplicationConfig = {
  providers: [
    // DatePipe,
    // {
    //     provide: HTTP_INTERCEPTORS, 
    //     useClass: WebApiHttpInterceptor, 
    //     multi: true
    // },
    // {
    //     provide: NGX_OHI_ENVIRONMENT, 
    //     useValue: environment
    // },
    // {
    //     provide: ErrorHandler,
    //     useClass: ServerLoggerService
    // },
    // {
    //     provide: ICON_SETTINGS,
    //     useValue: {
    //         type: 'font',
    //     }
    // },    
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withInterceptorsFromDi())
  ]
};
